<div class="text-center">
    <div class="progress woo-progress">
      <div class="progress-bar" [ngStyle]="{'width': displayProgress() + '%'}"></div>
  </div>
  <h3>{{displayProgress()}}%</h3>
</div>